export const featureFlags = Object.freeze({});
